import { currentTheme as currentVizTheme, refreshTheme } from 'devextreme/viz/themes';
import { current } from 'devextreme/ui/themes'
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';

const themes = ['light', 'dark'] as const;

type Theme = typeof themes[number];

function toTheme(value: string): Theme | null {
	if (themes.includes(value as Theme)) {
		return value as Theme;
	}
	return null;
}

function getNextTheme(theme?: Theme) {
	return themes[themes.indexOf(theme) + 1] || themes[0];
}

@Injectable({
	providedIn: 'root'
})
export class ThemeService {
	private _storageService: StorageService;
	private themeMarker = 'theme-';

	constructor(storageService: StorageService) {
		this._storageService = storageService;
		this.currentTheme = toTheme(this._storageService.getTheme()) 
			|| getNextTheme();
		this.isDark = new BehaviorSubject<boolean>(this.currentTheme === 'dark');
	}

	public currentTheme: Theme;

	public isDark: BehaviorSubject<boolean>;

	private getThemeStyleSheets() {
		return Array.from(document.styleSheets).filter(
			(styleSheet) => styleSheet?.href?.includes(this.themeMarker)
		);
	}

	public setAppTheme(theme = this.currentTheme) {
		this.getThemeStyleSheets().forEach((styleSheet) => {
			styleSheet.disabled = !styleSheet?.href?.includes(`${this.themeMarker}${theme}`);
		});

		this.currentTheme = theme;
		this.isDark.next(this.currentTheme === 'dark');

		const regexTheme = new RegExp(`\\.(${themes.join('|')})`, 'g');
		currentVizTheme(currentVizTheme().replace(regexTheme, `.${theme}`));
		refreshTheme();

		this._storageService.setTheme(this.currentTheme);
	}

	getCurrentTheme() {
		return this.currentTheme;
	}

	isFluent(): boolean {
		return current().includes('fluent');
	}

	public switchTheme() {
		this.currentTheme = getNextTheme(this.currentTheme);
		this.setAppTheme(this.currentTheme);
	}
}
